var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSleeps = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.99 12.27a1 1 0 0 1-1-1v-2.2a.47.47 0 0 0-.47-.47H4.66a.47.47 0 0 0-.46.47v2.2a1 1 0 1 1-2 0v-2.2A2.47 2.47 0 0 1 4.66 6.6h5.87a2.48 2.48 0 0 1 2.46 2.47v2.2a1 1 0 0 1-1 1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.8 12.27a1 1 0 0 1-1-1v-2.2a.47.47 0 0 0-.47-.47h-5.87a.46.46 0 0 0-.46.47v2.2a1 1 0 1 1-2 0v-2.2a2.47 2.47 0 0 1 2.46-2.47h5.87a2.48 2.48 0 0 1 2.47 2.47v2.2a1 1 0 0 1-1 1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.99 18.87h-22a1 1 0 0 1-1-1v-4.65a3 3 0 0 1 3-3h18.05a3 3 0 0 1 3 3v4.65a1 1 0 0 1-1.05 1m-21-2h20v-3.65a1 1 0 0 0-1-1h-18a1 1 0 0 0-1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.99 21.8a1 1 0 0 1-1-1v-2.93a1 1 0 1 1 2 0v2.93a1 1 0 0 1-1 1m22 0a1 1 0 0 1-1-1v-2.93a1 1 0 1 1 2 0v2.93a1 1 0 0 1-1 1m-2.19-9.53a1 1 0 0 1-1-1v-6.6a.47.47 0 0 0-.47-.47H4.66a.47.47 0 0 0-.46.47v6.6a1 1 0 1 1-2 0v-6.6A2.47 2.47 0 0 1 4.66 2.2h14.67a2.48 2.48 0 0 1 2.47 2.47v6.6a1 1 0 0 1-1 1"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgSleeps;